import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';

const ModalEntregasParcialesComponent = (props) => {

    const entregasRealizadas = props.historial

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 850,
        height: 470,
        bgcolor: '#E3EFF1',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black'
    };

    const [openModalEntregas, setOpenModalEntregas] = React.useState(true);

    const handleCloseModal = () => {
        setOpenModalEntregas(false)
        props.setOpenModalEntregas.setOpenModalEntregas()
    }

    const columns = [
        { field: 'numEntrega', headerName: 'Número de entrega', headerAlign: 'center', flex: 1.5 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', flex: 1 },
        { field: 'hologramasEntregados', headerName: 'Hologramas entregados', headerAlign: 'center', flex: 1.5 },
        { field: 'folioInicial', headerName: 'Folio Inicial', headerAlign: 'center', flex: 1 },
        { field: 'folioFinal', headerName: 'Folio Final', headerAlign: 'center', flex: 1 },
    ]

    const rows = []
    let id= 0
    entregasRealizadas?.map(anexo => {
        rows.push({
            id: uuidv4(), numEntrega: Number(Number(id)+1), fecha: anexo.fecha.substring(0, 10),
            hologramasEntregados: anexo.hologramasentregados,
            folioInicial: anexo.folioinicial, folioFinal: anexo.foliofinal
        })
        id++
    })

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModalEntregas}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger' style={{ color: "white" }}>
                            <center ><h3 style={{ color: "#0D717C", fontFamily: "Montserrat", fontWeight: "bold" }}> Entregas realizadas </h3></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" style={{ color: "black", textAlign: 'justify' }}>
                            <Box sx={{ height: 318, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={4}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#4399A4',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <button className={`btn btn-outline-success`} style={{ width: '70%' }} onClick={() => handleCloseModal()}>Aceptar</button>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalEntregasParcialesComponent)
